export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";